import search from '../search'

export default function searchFactory (document, moduleHTML, appEventEmitter) {
  getAutocompleteService()
    .then((autocompleteService) => search(document, moduleHTML, appEventEmitter, autocompleteService))
}

// https://developers.google.com/places/web-service/autocomplete
function getAutocompleteService () {
  if (isGoogleReady()) {
    return Promise.resolve(new window.google.maps.places.AutocompleteService())
  }

  return waitForGoogle()
    .then(() => new window.google.maps.places.AutocompleteService())
}

function isGoogleReady () {
  return window && window.google && window.google.maps && window.google.maps.places && window.google.maps.places.Autocomplete && typeof window.google.maps.places.Autocomplete === 'function'
}

function waitForGoogle () {
  return new Promise((resolve) => {
    const waitForGoogleInterval = setInterval(() => {
      // eslint-disable-next-line no-undef
      if (isGoogleReady()) {
        clearInterval(waitForGoogleInterval)
        return resolve()
      }
    }, 300)
  })
}
